import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";

const LANGUAGE_OPTIONS = [
  { value: "english",  label: "English" },
  { value: "german",   label: "Deutsch" },
  { value: "french",   label: "Français" },
  { value: "dutch",    label: "Nederlands" },
];

// Shown in all 4 languages simultaneously so any user can identify it
const MULTILANG_LABEL =
  "Select Language  ·  Sprache auswählen  ·  Choisir la langue  ·  Taal kiezen";

export const LanguageSelectorCard = ({ language, onLanguageChange }) => (
  <Box sx={{ maxWidth: 800, mx: "auto", mb: 3 }}>
    <Card
      elevation={0}
      sx={{
        border: "1px solid #dbeafe",
        borderRadius: 2,
        background: "linear-gradient(135deg, #f0f7ff 0%, #ffffff 60%, #eef5ff 100%)",
      }}
    >
      <CardContent sx={{ px: { xs: 3, sm: 4 }, py: { xs: 2, sm: 2.5 }, "&:last-child": { pb: { xs: 2, sm: 2.5 } } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 1.5, sm: 2 },
          }}
        >
          {/* Left: icon + multilingual label */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flex: 1, minWidth: 0 }}>
            <LanguageIcon sx={{ color: "#163666", fontSize: 22, flexShrink: 0 }} />
            <Typography
              variant="body2"
              sx={{
                color: "#374151",
                fontWeight: 500,
                lineHeight: 1.55,
                fontSize: { xs: "0.78rem", sm: "0.825rem" },
              }}
            >
              {MULTILANG_LABEL}
            </Typography>
          </Box>

          {/* Right: dropdown */}
          <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 160 }, flexShrink: 0 }}>
            <Select
              value={language}
              onChange={(e) => onLanguageChange(e.target.value)}
              displayEmpty
              sx={{
                borderRadius: 1.5,
                backgroundColor: "#fff",
                fontWeight: 600,
                fontSize: "0.875rem",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#bfdbfe" },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#163666" },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#163666",
                  borderWidth: 2,
                },
              }}
            >
              {LANGUAGE_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value} sx={{ fontWeight: 500 }}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </CardContent>
    </Card>
  </Box>
);
